import React, { Fragment } from 'react';
import { InventoryProgressBar } from './components/ProgressBar';
import { ProgressByDepartment } from './components/ProgressByDepartment';
import Navbar from '../../components/Navbar';
import { useSelector } from 'react-redux';
import { WidgetBar } from './components/WidgetBar';
import { UserRequests } from './components/UserRequests';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { AssetProgressionWidgetBar } from './components/AssetProgressionWidgetBar/index';
import { determineITAdmin } from '../AssetRelocation/TransferredItems/components/determineITAdmin';

export const HomePage = (props: any) => {
  const [itAdmin, setItAdmin] = React.useState(false);

  const { user } = useSelector((state: any) => ({ user: state.user }));
  const url = props.match.url;
  const newProp = url === '/userRequests' ? 'user' : 'dept';

  React.useEffect(() => {
    setItAdmin(determineITAdmin(user));
  }, []);

  const hideFromGuest = user.currentRole.roleName === 'Guest';

  return (
    <Fragment>
      <Navbar />

      {hideFromGuest ? <UserRequests user={user} requests={newProp} /> : null}

      {!hideFromGuest && (
        <Tabs justify id='mainscreentabs' className='mb-3 nav nav-tabs' fill>
          <Tab eventKey='receiving' title='Receiving and Transfers'>
            <UserRequests user={user} requests={newProp} />
            {hideFromGuest ? null : <AssetProgressionWidgetBar user={user} request={newProp} itAdmin={itAdmin} />}
          </Tab>

          <Tab eventKey='inventory' title='Inventory'>
            {hideFromGuest ? null : <InventoryProgressBar />}
            {hideFromGuest ? null : <ProgressByDepartment />}
          </Tab>
        </Tabs>
      )}
    </Fragment>
  );
};
